import React from 'react';
import { useIntl } from 'react-intl';
import ErrorLayout from '@/views/_layouts/ErrorLayout';

export interface ErrorViewProps {
  errorCode?: string | number;
}

function ErrorView({ errorCode }: ErrorViewProps) {
  const { formatMessage, messages } = useIntl();

  function getErrorMessage() {
    let localeKey = `views.errors.message.${errorCode}`;
    if (!messages[localeKey]) {
      localeKey = 'views.errors.message.unknown';
    }
    return formatMessage({ id: localeKey });
  }

  const message = getErrorMessage();

  return (
    <ErrorLayout>
      <img alt={`${errorCode}`} src="/resources/images/error/default.svg" />
      <h2>{message}</h2>
    </ErrorLayout>
  );
}

export default ErrorView;
